import instance from '@apis/instance';
import { SliceResponse } from '@models/page';
import {
    GetStampHistoriesParams, StampAutoIssueResponse,
    StampCardSorter,
    StampCardsResponse,
    StampHistoryRow,
} from '@models/stamp';

class StampApi {
    static getStampCards(sorter: StampCardSorter): Promise<StampCardsResponse> {
        return instance.get('/v0/stamp-cards', { params: { sorter } });
        // return Promise.resolve(mockStampCardsProject);
        // return Promise.resolve(mockStampCardsProject);
    }

    static getStampHistories(params: GetStampHistoriesParams): Promise<SliceResponse<StampHistoryRow>> {
        // return Promise.resolve(mockStampHistories(params.page));
        return instance.get('/v0/stamp-card/history', { params });
    }

    static autoIssueCoupons(): Promise<StampAutoIssueResponse> {
        return instance.post('/v0/stamp/auto-issue');
    }
}

export default StampApi;
